import { Dialog } from 'quasar'

export default {
  // inject: ['app'],
  data () {
    return {}
  },
  methods: {
    async get (name, model, callback, errorCallback) {
      return this.$http.api
        .get(
          name,
          {
            params: model
          },
          {}
        )
        .then(response => {
          if (callback) {
            callback(response.data)
          }
        }).catch(e => {
          if (errorCallback) {
            errorCallback(e.response)
          }
        })
    },
    async post (name, model, callback, errorCallback) {
      return this.$http.api.post(name, model).then(response => {
        if (callback) {
          callback(response.data)
        }
      }).catch(e => {
        if (errorCallback) {
          errorCallback(e.response)
        }
      })
    },
    download (name, model, callback) {
      return this.$http.download
        .get(name, { params: model })
        .then(callback)
    },
    getAddress (address, callback) {
      if (typeof (address.lat) !== 'undefined' && typeof (address.lng) !== 'undefined') {
        return this.$http.api.get(`https://gist.motc.gov.tw/gist_api/V2/Map/GeoCode/Address/${address.lat}%2C${address.lng}?$format=GEOJSON`)
      } else {
        return this.$http.api.get(`https://gist.motc.gov.tw/gist_api/V2/Map/GeoCode/Address/${encodeURIComponent(address)}?$format=GEOJSON`)
      }
    },
    isAllow (itemCode) {
      return this.$store.getters.getApplicationItemValue({
        path: this.$router.currentRoute.path,
        itemCode: itemCode
      })
    },
    successMessage (name) {
      this.$q.notify({
        color: 'green',
        icon: 'warning',
        position: 'top-right',
        message: name,
        timeout: 1200
      })
    },
    warningMessage (args) {
      this.$q.notify({
        color: args.color ? args.color : 'orange',
        icon: args.icon ? args.icon : 'warning',
        positionL: args.position ? args.position : 'bottom',
        message: args.message,
        timeout: args.timeout ? args.timeout : '1200'
      })
    },
    showError (text) {
      Dialog.create({
        title: '提示訊息',
        message: text,
        icon: 'fa-exclamation',
        color: '#3399ff',
        // color: 'primary',
        btnColor: 'blue',
        ok: '確定'
      })
    },
    message (message, okNamem, cancelName) {
      this.$q.dialog({
        title: '系統提示訊息',
        message: message,
        ok: okNamem,
        cancel: cancelName,
        // can't dimiss the popup
        persistent: true
      })
    },
    confirm (message, okNamem, cancelName, callbackOk, callbackCancel) {
      this.$q.dialog({
        title: '系統提示訊息',
        message: message,
        ok: okNamem,
        cancel: cancelName,
        persistent: true
      }).onOk(() => {
        callbackOk()
        console.log('OK: click OK fuction')
      }).onCancel(() => {
        callbackCancel()
        console.log('cancel: click cancel fuction')
      })
    }
  }
}
